import { coreApi } from "./coreApi";

export const reportApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getTotalSales: builder.query({
      query: () => ({
        url: "/reports/sales/successful",
        method: "GET",
      }),
    }),
    getDailySales: builder.query({
      query: () => ({
        url: "/reports/sales/daily",
        method: "GET",
      }),
    }),
    getWeeklySales: builder.query({
      query: () => ({
        url: "/reports/sales/weekly",
        method: "GET",
      }),
    }),
    getMonthlySales: builder.query({
      query: () => ({
        url: "/reports/sales/monthly",
        method: "GET",
      }),
    }),
    getPendingSales: builder.query({
      query: () => ({
        url: "/reports/sales/pending",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetTotalSalesQuery,
  useGetDailySalesQuery,
  useGetWeeklySalesQuery,
  useGetMonthlySalesQuery,
  useGetPendingSalesQuery,
} = reportApi;
